import { Stack, Typography, Switch } from "@mui/material";
import { useCallback, ChangeEvent } from "react";
import { useUpdateProviderSpecialtyMutation } from "src/api/services/providersApi";
import { ProviderSpecialty } from "src/api/types";

interface Props {
  providerSpecialty: ProviderSpecialty;
}

const Specialty = ({ providerSpecialty }: Props) => {
  const [updateSpecialty] = useUpdateProviderSpecialtyMutation();
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      updateSpecialty({
        provider_id: providerSpecialty.provider_id,
        specialty: providerSpecialty.specialty,
        updates: {
          active: event.target.checked,
        },
      });
    },
    [
      providerSpecialty.provider_id,
      providerSpecialty.specialty,
      updateSpecialty,
    ]
  );

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography id={`label-${providerSpecialty.specialty}`}>
        {providerSpecialty.specialty}
      </Typography>
      <Switch
        color="secondary"
        checked={providerSpecialty.active}
        onChange={handleChange}
      />
    </Stack>
  );
};

export default Specialty;
